<template>
	<el-container>
		<el-main style="width: 100%;height: 100%;">
			<div style="margin-bottom: 30px;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">Middleman管理</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">机器人列表</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div style="width: 100%;margin-top: 20px;">
				<div style="margin-bottom: 20px;">
					<el-button type="primary" size="normal" @click="addRobot">添加机器人</el-button>
				</div>
				<el-table :data="tableData" stripe border highlight-current-row style="width: 100%"
					:header-cell-style="headerStyle" :cell-style="cellStyle">
					<el-table-column prop="url" label="引擎地址" width="380" show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="heartbeat_url" label="心跳地址" width="200" show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="concurrency" label="并发量">
					</el-table-column>
					<el-table-column prop="onlineStatus" label="在线状态">
					</el-table-column>
					<el-table-column prop="publishStatus" label="发布状态">
					</el-table-column>
					<el-table-column fixed="right" label="操作" width="200">
						<template slot-scope="scope">
							<el-button type="text" size="small" v-if="scope.row.publishStatus == 1"
								@click="opRobot(scope.row)">禁用</el-button>
							<el-button type="text" size="small" v-else @click="opRobot(scope.row)">启用</el-button>
							<el-button type="text" size="small" @click="editRobot(scope.row)">编辑</el-button>
							<el-button type="text" size="small" @click="deleteRobot(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-dialog :title="isEdit?'编辑机器人':'添加机器人'" :visible.sync="dialogFormVisible" center 
			:close-on-click-modal="false" :close-on-press-escape="false">
				<el-form :model="form" label-width="120px" style="width: 80%;" :rules="formRules" ref="form">
					<el-form-item label="引擎地址" prop="url">
						<el-input v-model="form.url" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="引擎心跳地址" prop="heartbeat_url">
						<el-input v-model="form.heartbeat_url" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="并发量" prop="concurrency">
						<el-input v-model.number="form.concurrency" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="在线状态" prop="onlineStatus">
						<el-select v-model="form.onlineStatus">
							<el-option label="0-离线" value="0"></el-option>
							<el-option label="1-在线" value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发布状态" prop="publishStatus">
						<el-select v-model="form.publishStatus">
							<el-option label="0-下线" value="0"></el-option>
							<el-option label="1-发布" value="1"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisible = false">取 消</el-button>
					<el-button type="primary" @click="confirmAction('form')">确 定</el-button>
				</div>
			</el-dialog>
		</el-main>
	</el-container>
</template>

<script>
	import {MessageBox} from 'element-ui';
	export default {
		data() {
			var validateConcurrency = (rule, value, callback) =>{
				if(!Number.isInteger(value) || value < 0){
					callback(new Error("请输入正整数"))
				}else{
					callback()
				}
			}
				
			return {
				tableData: [],
				dialogFormVisible: false,
				form: {
					url:'',
					heartbeat_url: '',
					concurrency: 0,
					onlineStatus: '',
					publishStatus: '',
				},
				isEdit:false,
				editId:'',
				formRules:{
					url:[{required: true, message: '请输入引擎地址', trigger: 'blur'}],
					heartbeat_url:[{required: true, message: '请输入引擎心跳地址', trigger: 'blur'}],
					concurrency:[
						{required: true, message: '请输入并发量', trigger: 'blur'},
						{validator: validateConcurrency, trigger: 'change' }
					],
					onlineStatus:[{required: true, message: '请选择在线状态', trigger: 'blur'}],
					publishStatus:[{required: true, message: '请选择发布状态', trigger: 'blur'}],
				}
			}
		},

		created() {
			this.getRobotsRequest()
		},

		methods: {
			async getRobotsRequest() {
				var api = "/manager/middleman/manage/robot/list"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
				})

				if (response.resultCode == 10000) {
					this.tableData = response.data
				} else {
					this.$message.error(response.desc)
				}
			},

			headerStyle({
				rowIndex,
				columnIndex
			}) {
				if (rowIndex == 0 && columnIndex == 5) {
					return 'text-align:center;color:#000000'
				} else {
					return 'text-align:left;padding:15px;color:#000000'
				}
			},

			cellStyle({
				columnIndex
			}) {
				if (columnIndex == 5) {
					return 'text-align:center'
				} else {
					return 'text-align:left;padding:15px;'
				}
			},

			deleteRobot(robotObj) {
				let tipMsg = "是否确认删除该机器人？"
				MessageBox.alert(tipMsg, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					showCancelButton: true,
					dangerouslyUseHTMLString: true
				}).then(() =>{
					this.deleteRot(robotObj)
				}).catch(() =>{
					this.$message.info('取消删除')
				})
				
			},
			
			async deleteRot(robotObj) {
				var api = "/manager/middleman/manage/robot/del/" + robotObj.id
				const response = await this.util.postRequest({
					url: api,
					method: "GET",
				})
				if (response.resultCode == 10000) {
					this.$message.success("删除机器人成功！")
					this.getRobotsRequest()
				} else {
					this.$message.error(response.desc)
				}
			},

			editRobot(robotObj) {
				console.log('robotset editRobot robotObj = ', robotObj)
				this.dialogFormVisible = true
				this.isEdit = true
				
				this.editId = robotObj.id
				this.form.url = robotObj.url
				this.form.heartbeat_url = robotObj.heartbeat_url
				this.form.concurrency = robotObj.concurrency
				this.form.onlineStatus = robotObj.onlineStatus
				this.form.publishStatus = robotObj.publishStatus
			},

			async opRobot(robotObj) {
				console.log('robotset opRobot robotObj = ', robotObj.publishStatus)
				var status = robotObj.publishStatus == 0 ? 1 : 0

				var api = "/manager/middleman/manage/robot/status/update"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						id: robotObj.id,
						status: status
					}
				})
				if (response.resultCode == 10000) {
					this.getRobotsRequest()
				} else {
					this.$message.error(response.desc)
				}
			},

			addRobot() {
				console.log('robotset addRobot')
				this.dialogFormVisible = true
				this.isEdit = false
				
				this.form.url = ''
				this.form.heartbeat_url = ''
				this.form.concurrency = ''
				this.form.onlineStatus = ''
				this.form.publishStatus = ''
			},
			
			confirmAction(formName) {
				this.$refs[formName].validate((valid) =>{
					if (valid){
						this.submitData()
					}else{
						this.$message.error('请注意查看配置信息是否正确!')
						return false
					}
				})
			},
			
			async submitData() {
				var data = {}
				if (this.isEdit) {
					data = Object.assign({}, this.form)
					data.id = this.editId
				} else {
					data = Object.assign({}, this.form)
				}
				
				var api = "/manager/middleman/manage/robot/save"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: data
				})
				
				if (response.resultCode == 10000) {
					this.$message.success(this.isEdit?'编辑机器人成功!':'添加机器人成功')
					this.dialogFormVisible = false
					this.getRobotsRequest()
				} else {
					this.$message.error(response.desc)
				}
			}
			
		}
	}
</script>

<style scoped="scoped">

</style>
